import {
  SimcardsOnlineGraphTypes,
  TransactionsPayGraphTypes,
} from '@utils/alarmsConstants';
import { Form, Select } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlarmMenuFilter } from '@hooks/useAlarmMenuFilter';
import SimcardsOnlineFields from './SimcardsOnlineFields/SimcardsOnlineFields';
import TransactionsPayFields from './TransactionsPayField/TransactionsPayFields';

type GraphComponentRenderer = (graphType: string) => JSX.Element;

interface GraphTypeComponentMap {
  [key: string]: GraphComponentRenderer;
}

interface CreateAlarmStepOneProps {
  readOnlyFields?: string[];
}

export function CreateAlarmStepOne({
  readOnlyFields = [],
}: CreateAlarmStepOneProps) {
  const { t } = useTranslation('create-alarm-step');
  const form = Form.useFormInstance();
  const tipoGrafico = Form.useWatch('tipoGrafico', form);

  const { allMenuFilter: selectOptions } = useAlarmMenuFilter({
    mode: 'create',
  });

  const graphTypeComponentMap = useMemo<GraphTypeComponentMap>(() => {
    const simcardsMap = Object.values(
      SimcardsOnlineGraphTypes,
    ).reduce<GraphTypeComponentMap>((acc, type) => {
      acc[type] = (graphType: string) => (
        <SimcardsOnlineFields
          graphType={graphType}
          readOnlyFields={readOnlyFields}
        />
      );
      return acc;
    }, {});

    const transactionsMap = Object.values(
      TransactionsPayGraphTypes,
    ).reduce<GraphTypeComponentMap>((acc, type) => {
      acc[type] = (graphType: string) => (
        <TransactionsPayFields
          graphType={graphType}
          readOnlyFields={readOnlyFields}
        />
      );
      return acc;
    }, {});

    return { ...simcardsMap, ...transactionsMap };
  }, [readOnlyFields]);

  return (
    <>
      <Form.Item
        name="tipoGrafico"
        label={t('create-alarm-step:stepOne.createAlarmGraphTypeField')}
        rules={[
          {
            required: true,
            message: t('create-alarm-step:stepOne.createAlarmGraphTypeequired'),
          },
        ]}
      >
        <Select
          style={{ textAlign: 'left' }}
          disabled={readOnlyFields.includes('tipoGrafico')}
          options={selectOptions}
        />
      </Form.Item>

      {tipoGrafico &&
        graphTypeComponentMap[tipoGrafico] &&
        graphTypeComponentMap[tipoGrafico](tipoGrafico)}
    </>
  );
}
